/**
 * Default: Components / Shared > List
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {
	SelectorEngine,
	Data,
	Manipulator,
	EventHandler
} from '@ifabnpm/bootstrap/dom.js';

import List from '@ifabnpm/bootstrap/component/list.js';

// -------
// Private
// -------


// ------
// Public
// ------

/**
 * Listen initialisieren und anpassen.
 *
 * @returns {Promise<void>}
 */
const init = async (o = {}) => {
	List.init();

	// SVG-Icon den Listeneinträgen einer ungeordneten Liste hinzufügen.
	const ulListItems = SelectorEngine.find('ul.list > li');
	const icon = `<span aria-hidden="true" class="svg-icon marker-li" data-svg-icon>
		<svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<use xlink:href="#svg-icon-list-item"></use>
		</svg>
	</span>`;

	for (const listItem of ulListItems) {
		Manipulator.elementPrepend(icon, listItem);
	}
};

// Export
export default {
	init: init
};
